(function ($) {
    function initMap($el) {

        var $markers = $el.find('.marker');

        var mapArgs = {
            zoom: $el.data('zoom') || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            styles: [{ "featureType": "poi.attraction", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.business", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.government", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.medical", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.park", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.place_of_worship", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.school", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.sports_complex", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#9ab1c7" }] }]
        };
        var map = new google.maps.Map($el[0], mapArgs);

        map.markers = [];
        $markers.each(function () {
            initMarker($(this), map);
        });

        centerMap(map);
        return map;
    }


    function initMarker($marker, map) {
        var activeIcon = {
            url: localize.themeurl + '/assets/img/poi_active.svg'
        };
        var normalIcon = {
            url: localize.themeurl + '/assets/img/poi1.png'
        };

        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };
        var id = $marker.data('id')
        var placename = $marker.data('placename')

        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: localize.themeurl + "/assets/img/poi1.png",
            id: id,
            label: { color: '#fff', fontWeight: 'bold', fontSize: '14px', text: placename, className: "map-marker--label" },
        });


        map.markers.push(marker);
        if ($marker.html()) {
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
        }
        //Infowindow + data
        google.maps.event.addListener(marker, 'click', function () {
            for (var j = 0; j < map.markers.length; j++) {
                map.markers[j].setIcon(normalIcon);
            }

            const place = localize.placesJson[marker.id];

            if (place.placename || place.placeimage) {

                this.setIcon(activeIcon)

                $('.infowindow').addClass('infowindow__active');

                if (place.placeimage) {
                    $('.infowindow img').show();
                    $('.infowindow img').attr("src", place.placeimage.url);
                } else {
                    $('.infowindow img').hide();
                }

                $('.infowindow h4').text(place.placename);
            }

        });
    }


    function centerMap(map) {
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });


        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());
        } else {
            map.fitBounds(bounds);
        }
    }


    $(document).ready(function () {
        $('.acf-map').each(function () {
            var map = initMap($(this));
        });
    });




})(jQuery);
